var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1570_2505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1570_2505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.425 15.9462L17.6208 8.75044L16.8246 7.95422L10.425 14.3538L7.21875 11.1475L6.42253 11.9438L10.425 15.9462ZM4.81744 21C4.29956 21 3.86719 20.8266 3.52031 20.4797C3.17344 20.1328 3 19.7004 3 19.1826V4.81744C3 4.29956 3.17344 3.86719 3.52031 3.52031C3.86719 3.17344 4.29956 3 4.81744 3H19.1826C19.7004 3 20.1328 3.17344 20.4797 3.52031C20.8266 3.86719 21 4.29956 21 4.81744V19.1826C21 19.7004 20.8266 20.1328 20.4797 20.4797C20.1328 20.8266 19.7004 21 19.1826 21H4.81744Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.913096d9f9577a3739bbbf44ff16f5b0.svg";
export { ForwardRef as ReactComponent };